export function funcFormatDate(dateTime) {
	const resultDate = dateTime.toLocaleDateString("vi-VN");
	return resultDate;
}
